import { type AuthController, createOidcAuth, WEB_CLIENTS } from '@saay/auth-web';

import { env } from './env.js';

const client = WEB_CLIENTS['admin-web'];

/**
 * Keycloak PKCE for `saay-admin-web` (T-01). The fake provider exists only in the dev server with
 * `VITE_AUTH_MODE=fake`: `import.meta.env.DEV` is `false` in `vite build`, so the branch and its
 * dynamic import are removed, and the build guard fails if src/dev/ ever reaches a bundle.
 */
export async function createAuth(): Promise<AuthController> {
  if (import.meta.env.DEV && env.authMode === 'fake') {
    const { createDevAuth } = await import('./dev/fake-auth.js');
    return createDevAuth();
  }
  return createOidcAuth({
    authority: env.oidcAuthority,
    clientId: client.clientId,
    // W4 review decision: a fresh login after 30 minutes idle; the API also refuses an /admin token whose `auth_time` is older than 10 hours.
    maxAgeSeconds: 30 * 60,
    origin: globalThis.location.origin,
  });
}
